export const getUserReadOnlyRoles = ({ user }) => {
  let roles = []
  if (user.isLoPhaseTwo || user.loReviewPending) {
    roles = [...roles, 'Loan Originator Phase 1', 'Loan Originator Phase 2']
  }

  if (user.isLoanProcessor) {
    roles = [...roles, 'In-house Processor']
  }

  return roles
}
